/**
 * Date métier, avec un marqueur quand la saisie réelle s'en écarte.
 *
 * Pourquoi : depuis la reprise de l'historique des factures fournisseur (2026-08-26), un
 * document peut porter la date du PDF (`invoice_date`, `date_order`…) alors qu'il a été
 * enregistré des mois plus tard. Odoo conserve la saisie réelle dans `create_date`, mais
 * elle n'est visible qu'en mode développeur. Sans indication à l'écran, un comptable voit
 * une facture de décembre 2025 sans savoir qu'elle a été reprise en août 2026.
 *
 * On n'affiche PAS deux dates systématiquement : dans le cas courant elles coïncident et la
 * redondance alourdirait la trentaine d'affichages de date de l'app. Le marqueur n'apparaît
 * qu'au-delà du seuil, et la date réelle est dans l'infobulle.
 */
const SEUIL_MS = 48 * 3600 * 1000;   // 48 h : absorbe les décalages normaux de saisie

function jour(d: string | false | null | undefined): string {
  if (!d) return '—';
  const t = new Date(String(d).replace(' ', 'T'));
  return Number.isNaN(t.getTime()) ? String(d) : t.toLocaleDateString('fr-CH');
}

/** true si la saisie réelle s'écarte nettement de la date métier. */
export function estReprise(
  value: string | false | null | undefined,
  createdAt: string | false | null | undefined,
): boolean {
  if (!value || !createdAt) return false;
  const v = new Date(String(value).replace(' ', 'T')).getTime();
  const c = new Date(String(createdAt).replace(' ', 'T')).getTime();
  if (Number.isNaN(v) || Number.isNaN(c)) return false;
  return c - v > SEUIL_MS;
}

export function BusinessDate(
  { value, createdAt }: { value: string | false | null | undefined; createdAt?: string | false | null }
) {
  const reprise = estReprise(value, createdAt ?? null);
  if (!reprise) return <>{jour(value)}</>;
  const titre = `Saisi le ${jour(createdAt)} — reprise d'un document antérieur`;
  return (
    <span className="bdate">
      {jour(value)}
      <abbr className="bdate-mark" title={titre} aria-label={titre}>⧗</abbr>
    </span>
  );
}
